import { CONTACT_EMAIL } from './content';

export const ROUTES = {
  home: '/',
  about: '/about',
  features: '/features',
  featureDetail: '/features/:id',
  meditation: '/meditation',
  meditationDetail: '/meditation/:id',
  guide: '/guide',
  products: '/products',
  productDetail: '/products/:slug',
  inquiry: '/inquiry',
  inquiryDetail: '/inquiry/:slug',
  faq: '/faq',
  support: '/support',
  contact: '/contact',
  contactDetail: '/contact/:type',
  privacy: '/privacy',
  terms: '/terms',
};

export const NAV_LINKS = [
  { path: '/about', label: '品牌故事' },
  { path: '/features', label: '功能特色' },
  { path: '/meditation', label: '冥想课程' },
  { path: '/guide', label: '使用流程' },
  { path: '/products', label: '产品设备' },
  { path: '/inquiry', label: '购买咨询' },
  { path: '/faq', label: '常见问题' },
  { path: '/support', label: '技术支持' },
  { path: '/contact', label: '联系我们' },
];

export const FOOTER_LINKS = {
  products: [
    { path: '/features', label: '功能特色' },
    { path: '/meditation', label: '冥想课程' },
    { path: '/products', label: '硬件周边' },
    { path: '/inquiry', label: '购买咨询' },
  ],
  help: [
    { path: '/guide', label: '使用教程' },
    { path: '/faq', label: '常见问题' },
    { path: '/support', label: '技术支持' },
  ],
  about: [
    { path: '/about', label: '品牌故事' },
    { path: '/contact/business', label: '商务合作' },
    { path: '/privacy', label: '隐私政策' },
    { path: '/terms', label: '用户协议' },
  ],
  contact: [
    { path: '/contact', label: '联系我们' },
    { path: '/inquiry', label: '购买咨询' },
    { path: '/contact/gift', label: '礼品采购' },
    {
      href: `mailto:${CONTACT_EMAIL}`,
      label: '邮箱沟通',
    },
  ],
};

export function featurePath(id) {
  return `/features/${id}`;
}

export function meditationPath(id) {
  return `/meditation/${id}`;
}

/** @deprecated use meditationPath */
export function spreadPath(id) {
  return meditationPath(id);
}

export function productPath(slug) {
  return `/products/${slug}`;
}

export function inquiryPath(slug = 'general') {
  return `/inquiry/${slug}`;
}

export function contactPath(type) {
  return `/contact/${type}`;
}

export function mailtoLink(subject, body = '') {
  const params = new URLSearchParams();
  params.set('subject', subject);
  if (body) params.set('body', body);
  return `mailto:${CONTACT_EMAIL}?${params.toString()}`;
}
